/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import * as tf from '@tensorflow/tfjs';

import {
  Row, Col, Label, Button,
  Card, CardBody, CardHeader,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';

import { get, post } from '../../helpers/api_helper';

function TVInductionForm(props) {
  const {
    t, sjn, onCancel, onSuccess,
  } = props;

  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [miList, setMiList] = useState([]);
  const [hpList, setHpList] = useState([]);
  const [addressing, setAddressing] = useState([]);
  const brandRef = useRef(null);
  const modelRef = useRef(null);
  const serialRef = useRef(null);

  toastr.options = {
    positionClass: 'toast-top-full-width',
    newestOnTop: true,
  };

  const predbrands = [
    'Hisense', 'Samsung', 'Westinghouse',
    'TCL', 'Vizio', 'Roku',
    'LG', 'Emerson', 'Sony',
    'Element', 'Philips', 'Sylvox',
    'Onn', 'Sharp', 'Toshiba',
    'JVC', 'Viotek', 'Insignia',
    'Sceptre', 'RCA', 'Supersonic',
    'ViewSonic', 'Curtis', 'Sanyo',
    'Dell', 'Acer', 'Hitachi',
    'Amazon', 'Sylvania', 'HP',
    'Cisco', 'NEC', 'Sansui',
    'InFocus', 'Polaroid', 'None',
    'Wren', 'Proscan', 'GPX',
    'ASUS', 'Syntax', 'Magnavox',
    'Hyundai', 'Super Sonic', 'Seiki',
    'Furrion', 'Haier', 'Sceptre', // Fixed duplicate "SPEPTRE"
    'TA', 'iLive', 'Dynex',
  ];

  const loadModel = async () => {
    const model = await tf.loadLayersModel('/models/brand-predictor/model.json');

    return model;
  };

  // Define constants for tokenizing and padding
  const CHAR_SET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const charToIndex = CHAR_SET.split('').reduce((acc, char, idx) => {
    acc[char] = idx + 1; // Start from 1; reserve 0 for padding
    return acc;
  }, {});
  const MAX_SEQUENCE_LENGTH = 50; // Ensure this matches training

  function padSequence(sequence, maxLength) {
    const padded = Array(maxLength).fill(0);
    for (let i = 0; i < sequence.length && i < maxLength; i += 1) {
      padded[i] = sequence[i];
    }
    return padded;
  }

  // Predict brand function
  async function predictBrand(serial, model) {
    // Tokenize and pad the serial
    const tokenized = serial.split('').map((char) => charToIndex[char] || 0);
    const padded = padSequence(tokenized, MAX_SEQUENCE_LENGTH);

    // Create tensor
    const inputTensor = tf.tensor2d([padded]);

    // Make prediction
    const prediction = model.predict(inputTensor);
    const probabilities = prediction.arraySync()[0];

    // Get the index of the highest probability
    const predictedIndex = probabilities.indexOf(Math.max(...probabilities));

    // Return the corresponding brand
    return predbrands[predictedIndex];
  }

  const loadMiList = async () => {
    try {
      const result = await get('/api/tvs/mi-list');

      setMiList(result);
    } catch (err) {
      toastr.error(t('Error loading MI list'), t('Error'));
    }
  };

  const loadHpList = async () => {
    try {
      const result = await get('/api/tvs/hp-list');

      const mp = new Map(result.map((row) => row.split(',')));

      setHpList(mp);
    } catch (err) {
      toastr.error(t('Error loading HP list'), t('Error'));
    }
  };

  useEffect(() => {
    const fetchAddressing = async () => {
      try {
        const result = await get(`/api/tvs/addressingFromSjn/${sjn}`);

        if (result === '') {
          toastr.error(t('Sort label not addressed!'), t('Error'));
        }

        setAddressing(result);
      } catch (err) {
        toastr.error(t('Sort label not addressed!'), t('Error'));
      }
    };

    const fetchData = async () => {
      try {
        const result = await get('/api/devices/brands');

        setBrands(result);
      } catch (err) {
        toastr.error(t('Error loading brands'), t('Error'));
      }
    };

    fetchData();
    fetchAddressing();
    serialRef.current.focus();
    loadMiList();
    loadHpList();
  }, []);

  const save = async (values) => {
    try {
      if (loading) return;

      setLoading(true);

      const data = { ...values };
      data.truck = addressing.truck || null;
      data.sourcing_orders_id = addressing.order_id || null;

      // classify the TV
      if (values.device_id === null) {
        // Find the device or create
        const device = await get(
          `/api/devices/find?brand=${encodeURIComponent(values.brand)}&model=${encodeURIComponent(values.model)}&size=${encodeURIComponent(values.size)}&create=1`,
        );

        if (device === '') {
          toastr.error(t('Error finding or creating device'), t('Error'));
          return;
        }

        data.device_id = device.id;
      }

      /**
       * Classification:
       * R = Repair
       * T = Teardown
       * P = Plug and Play
       * S = Korea Samsung
       * L = Korea LG
       * H = Hisense
       * 3 = MI Tech 32"
       * M = MI Tech Samsung
       * K = K-Bid
      */
      if (data.screen_good === '1') {
        if (data.powers_on === '1') {
          if (data.backlight === '0') {
            data.classification = 'R';
          } else {
            data.classification = data.has_etc === '1' ? 'P' : 'K';
          }
        } else {
          data.classification = 'R';
        }
      } else {
        if (parseInt(data.size, 10) < 32) {
          data.classification = 'T';
        } else {
          if (data.brand === 'Samsung') {
            if (data.good_frame === '1') {
              data.classification = parseInt(data.size, 10) === 82 ? 'T' : 'S';
            } else {
              data.classification = 'T';
            }
          } else if (data.brand === 'LG') {
            if (data.good_frame === '1') {
              data.classification = 'L';
            } else {
              data.classification = 'T';
            }
          } else if (parseInt(data.size, 10) === 32) {
            if (data.truck.supplier_id === 0) { // TODO update with correct supplier_id for MI Tech
              if (data.brand === 'Vizio') {
                data.classification = 'T';
              } else {
                data.classification = data.good_frame === '1' ? '3' : 'T';
              }
            }
            if (data.brand === 'Hisense' || data.brand === 'TCL') {
              data.classification = data.good_frame === '1' ? '3' : 'T';
            } else {
              data.classification = 'T';
            }
          } else {
            if (data.brand === 'Hisense' && !['40', '43', '50', '55', '58', '65', '75'].includes(data.size)) {
              data.classification = data.good_frame === '1' ? 'H' : 'T';
            } else {
              data.classification = 'T';
            }
          }
        }
      }

      if (data.classification === 'T') {
        if (miList.includes(data.model) && data.good_frame === '1') {
          data.classification = 'M';
        }

        if (data.classification === 'T') {
          if (data.good_frame === '0' && hpList.has(data.model)) {
            if (hpList.get(data.model) !== undefined) {
              data.classification = hpList.get(data.model);
            } else {
              data.classification = '1';
            }
          }
        }
      }

      data.sjn = sjn;

      delete data.good_frame;
      delete data.has_etc;
      delete data.powers_on;
      delete data.screen_good;
      delete data.backlight;
      delete data.size;

      const tvData = await post('/api/tvs', data);

      await get(`/api/tvs/print/${tvData.id}`);

      props.onSuccess();
    } catch (error) {
      toastr.error(t('Error inducting TV'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  const loadModels = async () => {
    try {
      const result = await get(`/api/devices/models?brand=${encodeURIComponent(brandRef.current.value)}`);

      setModels(result);
    } catch (err) {
      toastr.error(t('Error loading models'), t('Error'));
    }
  };

  const ValidationSchema = Yup.object().shape({
    serial: Yup.string(),
    device: Yup.object().shape({
      id: Yup.number(),
    }),
    brand: Yup.string().required(t('Brand is required')),
    model: Yup.string().required(t('Model is required')),
    size: Yup.string().required(t('Size is required')),
    version: Yup.string(),
    truck: Yup.object().shape({
      id: Yup.number(),
    }),
    screen_good: Yup.mixed()
      .required(t('Please answer the questions')),
  });

  const hisenseSizes = ['40', '43', '50', '55', '58', '65', '75'];

  const jsx = (
    <Formik
      enableReinitialize
      initialValues={{ screen_good: null }}
      validationSchema={ValidationSchema}
      onSubmit={(values) => {
        save(values);
      }}
    >
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <Form id="TVForm" autoComplete="off">
          <Row>
            <Col lg="4">
              <Card>
                <CardHeader className="border-bottom bg-warning bg-soft">
                  <h4 className="float-end">{parseInt(sjn, 36).toString()}</h4>
                  <h4>{sjn}</h4>
                </CardHeader>
                <CardBody className="p-4">
                  <Row className="pb-3 mb-3">
                    <Col sm="8">
                      <Label
                        for="serial"
                        className="pe-0 ps-0"
                      >
                        {props.t('Serial')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control input-lg ${(errors.serial && touched.serial ? 'is-invalid' : '')}`}
                        id="serial"
                        name="serial"
                        innerRef={serialRef}
                        onKeyDown={async (e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            const mdl = await loadModel();
                            const brand = await predictBrand(values.serial, mdl);

                            setFieldValue('brand', brand);

                            setTimeout(() => {
                              modelRef.current.focus();
                            }, 200);
                          }
                        }}
                      />
                      <div className="help-block text-muted pt-1">
                        {props.t('Serial number on the TV')}
                      </div>
                      <ErrorMessage
                        name="serial"
                        component="div"
                        className="text-danger"
                      />
                    </Col>
                  </Row>

                  <Row className="pb-3">
                    <Col sm="6">
                      <Label
                        for="brand"
                        className="pe-0 ps-0"
                      >
                        {props.t('Brand')}
                      </Label>
                      <div className="position-relative">
                        <Field
                          type="text"
                          innerRef={brandRef}
                          className={`form-control input-lg ${(errors.brand && touched.brand ? 'is-invalid' : '')}`}
                          id="brand"
                          name="brand"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                            }

                            if (e.key === 'ArrowDown') {
                              e.preventDefault();
                            }

                            setFieldValue('model', '');
                            setFieldValue('device_id', null);
                          }}
                        />
                        {values.brand && values.brand.length > 0
                          && (brandRef.current == document.activeElement
                            || !brands.includes(values.brand))
                          && (
                            <div className="position-absolute" style={{ width: '100%', marginTop: '1px', zIndex: 100 }}>
                              <ul className="list-group">
                                {brands.filter((brand) => (
                                  brand.toLowerCase().startsWith(values.brand.toLowerCase())
                                )).map((brand) => (
                                  <li
                                    key={brand.id}
                                    className="list-group-item position-relative"
                                    style={{ padding: '0px' }}
                                  >
                                    <a
                                      href="#"
                                      className="text-dark"
                                      style={{ display: 'block', padding: '0.47rem 0.75rem' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue('brand', brand);

                                        setTimeout(() => {
                                          modelRef.current.focus();
                                        }, 100);
                                      }}
                                    >
                                      {brand}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        <ErrorMessage
                          name="brand"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>

                    {values.brand && values.brand.length > 0 && brands.includes(values.brand) && (
                    <Col sm="6">
                      <Label
                        for="model"
                        className="pe-0 ps-0"
                      >
                        {props.t('Model')}
                      </Label>
                      <div className="position-relative">
                        <Field
                          type="text"
                          className={`form-control input-lg ${(errors.model && touched.model ? 'is-invalid' : '')}`}
                          id="model"
                          name="model"
                          innerRef={modelRef}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                            }
                          }}
                          onFocus={() => {
                            loadModels();
                          }}
                        />
                        {values.model && values.model.length > 0
                          && (modelRef.current == document.activeElement
                            || models.filter((mdl) => mdl.model === values.model).length === 0)
                          && (
                            <div className="position-absolute" style={{ width: '100%', marginTop: '1px', zIndex: 100 }}>
                              <ul className="list-group">
                                {models.filter((mdl) => (
                                  mdl.model.toLowerCase().startsWith(values.model.toLowerCase())
                                )).map((model) => (
                                  <li
                                    key={model.id}
                                    className="list-group-item position-relative"
                                    style={{ padding: '0px' }}
                                  >
                                    <a
                                      href="#"
                                      className="text-dark"
                                      style={{ display: 'block', padding: '0.47rem 0.75rem' }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setFieldValue('model', model.model);
                                        setFieldValue('device', model);
                                      }}
                                    >
                                      {model.model}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        <ErrorMessage
                          name="model"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>
                    )}
                  </Row>

                  <style>
                    {`
                      .list-group-item a:focus {
                        background-color: rgba(249, 195, 25, 1) !important;
                      }
                    `}
                  </style>

                  <Row className="pb-3">
                    <Col sm="6">
                      <Label
                        for="size"
                        className="pe-0 ps-0"
                      >
                        {props.t('Size')}
                      </Label>
                      <Field
                        as="select"
                        className={`form-control input-lg ${(errors.size && touched.size ? 'is-invalid' : '')}`}
                        id="size"
                        name="size"
                      >
                        <option value="">Select a size</option>
                        {[17, 19, 24, 26, 27, 32, 34, 37, 39, 40, 42, 43, 48, 49, 50, 55, 58, 60,
                          65, 70, 75, 77, 80, 82, 83, 85, 86, 90, 98, 100].map((size) => (
                            <option key={size} value={size}>
                              {size}
                              &quot;
                            </option>
                        ))}
                      </Field>
                      <div className="help-block text-muted pt-1">
                        {props.t('Size of the TV screen')}
                      </div>
                      <ErrorMessage
                        name="size"
                        component="div"
                        className="text-danger"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Label
                        for="version"
                        className="pe-0 ps-0"
                      >
                        {props.t('Version')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control input-lg ${(errors.version && touched.version ? 'is-invalid' : '')}`}
                        id="version"
                        name="version"
                      />
                      <ErrorMessage
                        name="version"
                        component="div"
                        className="text-danger"
                      />
                    </Col>
                  </Row>

                  <Button color="dark" className="ml-2 mt-3 btn-soft-dark" onClick={() => { onCancel(); }}>{t('Cancel')}</Button>
                  <Button color="success" className="ms-2 mt-3 btn-soft-success" type="submit">{t('Save')}</Button>
                </CardBody>
              </Card>
            </Col>

            <Col lg="4">
              <Card>
                <CardHeader className="border-bottom bg-warning bg-soft">
                  <h4>{t('TV Condition')}</h4>
                </CardHeader>
                <CardBody className="p-4 tv-induction-condition">
                  <div>
                    <h5 className="mb-3 fs-4 ps-3 pt-2 pb-2 tv-induction-condition__question">{t('Is the screen good?')}</h5>

                    <div className={`p-3 tv-induction-condition__options ${values.screen_good === null ? 'tv-induction-condition__options--pending' : ''} ${values.screen_good === '0' ? 'bg-danger bg-soft' : ''} ${values.screen_good === '1' ? 'bg-success bg-soft' : ''}`}>
                      <div className="form-check form-radio-success mb-3">
                        <Field
                          type="radio"
                          className={`form-check-input pt-1 pb-1 ${
                            errors.screen_good && touched.screen_good ? 'is-invalid' : ''
                          }`}
                          id="screen_good_yes"
                          name="screen_good"
                          value="1"
                        />
                        <Label
                          for="screen_good_yes"
                          className="form-check-label pb-1 fs-5"
                        >
                          {t('Yes, screen is GOOD')}
                        </Label>
                      </div>
                      <div className="form-check form-radio-danger">
                        <Field
                          type="radio"
                          className={`form-check-input pt-1 pb-1 form-radio-danger ${
                            errors.screen_good && touched.screen_good ? 'is-invalid' : ''
                          }`}
                          id="screen_good_no"
                          name="screen_good"
                          value="0"
                        />
                        <Label
                          for="screen_good_no"
                          className="form-check-label fs-5 pb-1"
                        >
                          {t('No, screen is BAD')}
                        </Label>
                      </div>
                    </div>
                  </div>

                  {values.screen_good === '1' && (
                    <div className="mt-3">
                      <h5 className="mb-3 fs-4 ps-3 pt-2 pb-2 tv-induction-condition__question">{t('Does the TV power on?')}</h5>
                      <div className={`p-3 tv-induction-condition__options ${values.powers_on === null ? 'tv-induction-condition__options--pending' : ''} ${values.powers_on === '0' ? 'bg-danger bg-soft' : ''} ${values.powers_on === '1' ? 'bg-success bg-soft' : ''}`}>
                        <div className="form-check form-radio-success mb-3">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 ${
                              errors.powers_on && touched.powers_on ? 'is-invalid' : ''
                            }`}
                            id="powers_on_yes"
                            name="powers_on"
                            value="1"
                          />
                          <Label
                            for="powers_on_yes"
                            className="form-check-label pb-1 fs-5"
                          >
                            {t('Yes, TV powers on')}
                          </Label>
                        </div>
                        <div className="form-check form-radio-danger">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 form-radio-danger ${
                              errors.powers_on && touched.powers_on ? 'is-invalid' : ''
                            }`}
                            id="powers_on_no"
                            name="powers_on"
                            value="0"
                          />
                          <Label
                            for="powers_on_no"
                            className="form-check-label fs-5 pb-1"
                          >
                            {t('No, TV does not power on')}
                          </Label>
                        </div>
                      </div>
                    </div>
                  )}

                  {values.size >= 32 && values.screen_good === '0'
                    && (
                      ['samsung', 'lg', 'vizio'].includes(values.brand.toLowerCase())
                      || (values.brand === 'Hisense' && hisenseSizes.includes(values.size))
                      || miList.includes(values.model)
                    )
                    && (
                    <div className="mt-3">
                      <h5 className="mb-3 fs-4 ps-3 pt-2 pb-2 tv-induction-condition__question">{t('Is the TV frame good?')}</h5>
                      <div className={`p-3 tv-induction-condition__options ${values.good_frame === null ? 'tv-induction-condition__options--pending' : ''} ${values.good_frame === '0' ? 'bg-danger bg-soft' : ''} ${values.good_frame === '1' ? 'bg-success bg-soft' : ''}`}>
                        <div className="form-check form-radio-success mb-3">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 ${
                              errors.good_frame && touched.good_frame ? 'is-invalid' : ''
                            }`}
                            id="good_frame_yes"
                            name="good_frame"
                            value="1"
                          />
                          <Label
                            for="good_frame_yes"
                            className="form-check-label pb-1 fs-5"
                          >
                            {t('Yes, frame is GOOD')}
                          </Label>
                        </div>
                        <div className="form-check form-radio-danger">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 form-radio-danger ${
                              errors.good_frame && touched.good_frame ? 'is-invalid' : ''
                            }`}
                            id="good_frame_no"
                            name="good_frame"
                            value="0"
                          />
                          <Label
                            for="good_frame_no"
                            className="form-check-label fs-5 pb-1"
                          >
                            {t('No, frame is BAD')}
                          </Label>
                        </div>
                      </div>
                    </div>
                    )}

                  {values.powers_on === '1' && (
                    <div className="mt-3">
                      <h5 className="mb-3 fs-4 ps-3 pt-2 pb-2 tv-induction-condition__question">{t('Does the backlight turn on?')}</h5>
                      <div className={`p-3 tv-induction-condition__options ${values.backlight === null ? 'tv-induction-condition__options--pending' : ''} ${values.backlight === '0' ? 'bg-danger bg-soft' : ''} ${values.backlight === '1' ? 'bg-success bg-soft' : ''}`}>
                        <div className="form-check form-radio-success mb-3">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 ${
                              errors.backlight && touched.backlight ? 'is-invalid' : ''
                            }`}
                            id="backlight_yes"
                            name="backlight"
                            value="1"
                          />
                          <Label
                            for="backlight_yes"
                            className="form-check-label pb-1 fs-5"
                          >
                            {t('Yes, backlight turns on')}
                          </Label>
                        </div>
                        <div className="form-check form-radio-danger">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 form-radio-danger ${
                              errors.backlight && touched.backlight ? 'is-invalid' : ''
                            }`}
                            id="backlight_no"
                            name="backlight"
                            value="0"
                          />
                          <Label
                            for="backlight_no"
                            className="form-check-label fs-5 pb-1"
                          >
                            {t('No, backlight does not turn on')}
                          </Label>
                        </div>
                      </div>
                    </div>
                  )}

                  {values.backlight === '1' && (
                    <div className="mt-3">
                      <h5 className="mb-3 fs-4 ps-3 pt-2 pb-2 tv-induction-condition__question">{t('Does the TV have a stand and remote?')}</h5>
                      <div className={`p-3 tv-induction-condition__options ${values.has_etc === null ? 'tv-induction-condition__options--pending' : ''} ${values.has_etc === '0' ? 'bg-danger bg-soft' : ''} ${values.has_etc === '1' ? 'bg-success bg-soft' : ''}`}>
                        <div className="form-check form-radio-success mb-3">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 ${
                              errors.has_etc && touched.has_etc ? 'is-invalid' : ''
                            }`}
                            id="has_etc_yes"
                            name="has_etc"
                            value="1"
                          />
                          <Label
                            for="has_etc_yes"
                            className="form-check-label pb-1 fs-5"
                          >
                            {t('Yes, has stand and remote')}
                          </Label>
                        </div>
                        <div className="form-check form-radio-danger">
                          <Field
                            type="radio"
                            className={`form-check-input pt-1 pb-1 form-radio-danger ${
                              errors.has_etc && touched.has_etc ? 'is-invalid' : ''
                            }`}
                            id="has_etc_no"
                            name="has_etc"
                            value="0"
                          />
                          <Label
                            for="has_etc_no"
                            className="form-check-label fs-5 pb-1"
                          >
                            {t('No, does not have stand and remote')}
                          </Label>
                        </div>
                      </div>
                    </div>
                  )}

                  {values.screen_good === '0' && parseInt(values.size, 10) >= 32 && values.brand === 'Samsung' && values.good_frame === '0' && (
                  <div className="mt-3">
                    <h5 className="mb-3 fs-4 ps-3 pt-2 pb-2 tv-induction-condition__question">{t('Does the TV have a good BACK?')}</h5>
                    <div className={`p-3 tv-induction-condition__options ${values.good_back === null ? 'tv-induction-condition__options--pending' : ''} ${values.good_back === '0' ? 'bg-danger bg-soft' : ''} ${values.good_back === '1' ? 'bg-success bg-soft' : ''}`}>
                      <div className="form-check form-radio-success mb-3">
                        <Field
                          type="radio"
                          className={`form-check-input pt-1 pb-1 ${
                            errors.good_back && touched.good_back ? 'is-invalid' : ''
                          }`}
                          id="good_back_yes"
                          name="good_back"
                          value="1"
                        />
                        <Label
                          for="good_back_yes"
                          className="form-check-label pb-1 fs-5"
                        >
                          {t('Yes, back is GOOD')}
                        </Label>
                      </div>
                      <div className="form-check form-radio-danger">
                        <Field
                          type="radio"
                          className={`form-check-input pt-1 pb-1 form-radio-danger ${
                            errors.good_back && touched.good_back ? 'is-invalid' : ''
                          }`}
                          id="good_back_no"
                          name="good_back"
                          value="0"
                        />
                        <Label
                          for="good_back_no"
                          className="form-check-label fs-5 pb-1"
                        >
                          {t('No, back is BAD')}
                        </Label>
                      </div>
                    </div>
                  </div>
                  )}
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Form>
      )}
    </Formik>
  );

  return jsx;
}

TVInductionForm.defaultProps = {
  onSuccess: () => {},
  onCancel: () => {},
};

TVInductionForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onSuccess: PropTypes.func,
  sjn: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(TVInductionForm));
